"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageCycleSchemaProperties = exports.PackageCycleSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.PackageCycleSchema = base_schema_1.BaseSchema.extend({
    start: zod_1.z.date(),
    packageInstanceId: zod_1.z.string(),
    end: zod_1.z.date().optional().nullable(),
    extensions: zod_1.z.number().optional().nullable(),
    rolledOver: zod_1.z.number().optional().nullable(),
    frequency: zod_1.z.number().optional().nullable(),
    extensionHistory: zod_1.z
        .array(zod_1.z.object({
        extendedBy: zod_1.z.string(),
        extendedOn: zod_1.z.date(),
        value: zod_1.z.number(),
        appliedRecurring: zod_1.z.boolean().optional().nullable(),
    }))
        .optional(),
    isPaused: zod_1.z.boolean().optional().nullable(),
    pausedOn: zod_1.z.date().optional().nullable(),
    pausedBy: zod_1.z.string().optional().nullable(),
    resumedBy: zod_1.z.string().optional().nullable(),
    resumedOn: zod_1.z.date().optional().nullable(),
});
exports.PackageCycleSchemaProperties = {
    collectionName: "packageCycles",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=package-cycle-schema.js.map